import { GET_FAQS } from '@/queries';

export const useGetFAQs = async () => {
  try {
    const { data } = await useGraphQL(GET_FAQS, null);
    return data.value.data.faqs?.items || [];
  } catch (error) {
    console.log('Error: Failed retrieving FAQs', error);
    return [];
  }
}
